import { render, staticRenderFns } from "./PriceControl.vue?vue&type=template&id=2a2d24f4&scoped=true"
import script from "./PriceControl.vue?vue&type=script&lang=js"
export * from "./PriceControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2d24f4",
  null
  
)

export default component.exports